import { render, staticRenderFns } from "./team-container-wrapper.vue?vue&type=template&id=256779d2&scoped=true&"
import script from "./team-container-wrapper.vue?vue&type=script&lang=ts&"
export * from "./team-container-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./team-container-wrapper.vue?vue&type=style&index=0&id=256779d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256779d2",
  null
  
)

export default component.exports